import * as Yup from "yup";
import { useFormik } from "formik";
import { registeringForm } from "../../../utils/string";
import Upload from "../../../assets/Images/Upload.svg";
import { useEffect, useRef, useState } from "react";
import {
  addAsset,
  addAssetAdvertisements,
  addCategori,
  addLocation,
  checkUnitNumber,
  getAssetStatuses,
  getContactById,
  getLocations,
  savePicture,
  uploadBulkImg,
} from "../../../services/vizyBilityServices";
import { getAllMachinesMaketList, getMasterModelsByMake } from "../../../services/machineService";
import { toast } from "react-toastify";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import { cleanObjectKeys, formatDate } from "../../../utils/helper";
import SignUpWarningModel from "../../model/signUpWarningModel";
import { useLocation, useNavigate } from "react-router-dom";
import WarningModal from "../../model/warningModel";
import { useMsal } from "@azure/msal-react";
import { ApplicationId, DefaultAssetID, Google_map_Key, vizybilityConfig } from "../../../api/url";
import { jwtDecode } from "jwt-decode";
import { postGetVizyBilityToken } from "../../../services/getVizyBilityToken";
import { getAzureUser } from "../../../services/updateAzureUser";
import { loginRequest } from "../../../config/msalConfig";
import { getGenericUserKey, getThirdPartyAzureService } from "../../../services/getThirdPartyAzureService";
import Button from "../../ui/Button";
import { getCategoryList } from "../../../services/machineService";
import { useAuthModal } from "../../../context/authModalContext";

const AddAdminMachineForm = ({ handleCloseMachinePopUp, handleResetPagination, editMachineInfo }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { instance, accounts } = useMsal();
  const { openModal } = useAuthModal();
  const Logout = localStorage.getItem("getAzureUserData");
  const [openWarning, setOpenWarning] = useState(false);
  const [previewImage, setPreviewImage] = useState(null); // Image for modal preview
  const [images, setImages] = useState([]);
  const [assetType, setAssetType] = useState([]);
  const [assetStatus, setAssetStatus] = useState([]);
  const [assetMake, setAssetMake] = useState([]);
  const [assetModel, setAssetModel] = useState([]);
  const [addMachineLoader, setAddMachineLoader] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [openPendingWarning, setOpenPendingWarning] = useState(localStorage.getItem("OpenWarning") || false);

  const [isLoading, setIsLoading] = useState(false);

  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  const inputRef = useRef(null);
  const formik = useFormik({
    initialValues: {
      year: "",
      type: "",
      model: "",
      serialNumber: "",
      manufacturers: "",
      machineHours: "",
      description: "",
      status: 1,
      price: "",
      currency: "USD",
      sortOrder: "1",
      images: [],
      location: "",
    },
    validationSchema: Yup.object({
      year: Yup.string().required("Year is required"),
      type: Yup.string().required("Category is required"),
      model: Yup.string().required("Model is required"),
      serialNumber: Yup.string().required("Serial Number is required"),
      manufacturers: Yup.string().required("Manufacturer is required"),
      machineHours: Yup.string().required("Machine Hours is required"),
      description: Yup.string().required("description is required"),
      images: Yup.array().min(1, "At least one image must be uploaded").required("Please upload at least one image"),
      status: Yup.string().required("Status is required"),
      price: Yup.string().required("Price is required"),
      currency: Yup.string().required("Currency is required"),
      sortOrder: Yup.string(),
      location: Yup.string().required("Location is required"),
    }),
    onSubmit: (values) => {
      if (Logout) {
        handleCheckUnitNumber(values);
      } else {
        console.log("values", values);
      }
    },
  });

  useEffect(() => {
    if (editMachineInfo?.AssetId) {
      formik.setValues({
        year: editMachineInfo?.Year,
        type: editMachineInfo?.AssetTypeId,
        model: editMachineInfo?.Model,
        serialNumber: editMachineInfo?.SerialNumber,
        description: editMachineInfo?.AssetDescription,
        status: 1,
        price: editMachineInfo?.Price,
        images: [{ New: false, preview: editMachineInfo?.AssetPictureUrl }],
        currency: "USD",
        location: "",
        machineHours: "",
        manufacturers: editMachineInfo?.MakeId,
        sortOrder: "1",
        LocationId: editMachineInfo.LocationId,
        location: editMachineInfo.LocationName,
        defultLocation: editMachineInfo.LocationName,
      }); // Set the formik values
      if (editMachineInfo?.AssetPictureUrl) {
        setImages([{ New: false, preview: editMachineInfo?.AssetPictureUrl }]);
      }
      // Note: Model fetching will happen via the manufacturer change useEffect below
    }
  }, []);

  // Fetch models when manufacturer/make changes
  useEffect(() => {
    console.log("Manufacturer changed:", formik.values.manufacturers, "AssetMake length:", assetMake.length);
    if (formik.values.manufacturers && assetMake.length > 0) {
      const selectedMake = assetMake.find((item) => item.MakeId == formik.values.manufacturers);
      console.log("Selected make:", selectedMake);
      if (selectedMake) {
        handleGetAssetModel(selectedMake.MakeName);
      }
    }
  }, [formik.values.manufacturers, assetMake]);

  useEffect(() => {
    if (Logout) {
      handleGetAssetType();
      handleGetAssetMake();
      handleGetAssetStatus();
    } else {
      setOpenWarning(true);
    }
  }, [refreshPage]);

  useEffect(() => {
    if (localStorage.getItem("StoreMachineData")) {
      const storedData = JSON.parse(localStorage.getItem("StoreMachineData"));
      const data = {
        ...storedData,
        images: JSON.parse(localStorage.getItem("StoreMachineImg")) || [], // Override the images property
      };
      formik.setValues(data); // Set the formik values
    }
  }, []);

  const handleGetAssetType = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getCategoryList(header, instance, accounts)
      .then((res) => {
        setAssetType(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGetAssetStatus = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getAssetStatuses(header, instance, accounts)
      .then((res) => {
        setAssetStatus(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGetAssetMake = () => {
    getAllMachinesMaketList(false)
      .then((res) => {
        setAssetMake(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGetAssetModel = (makeName) => {
    console.log("Fetching models for make:", makeName);
    const payload = {
      applicationId: ApplicationId,
      makeName: [makeName],
      isFromAdvertisement: false
    };

    getMasterModelsByMake(payload)
      .then((res) => {
        console.log("Models fetched successfully:", res.data);
        setAssetModel(res.data);

        // Check if current model value exists in the new model list
        const currentModel = formik.values.model;
        if (currentModel) {
          const modelExists = res.data.some((item) => item.Model === currentModel);
          if (!modelExists) {
            // Model doesn't exist in new list, clear it to show placeholder
            console.log("Current model not found in new list, clearing...");
            formik.setFieldValue("model", "");
          }
        }
      })
      .catch((err) => {
        console.log("Error fetching models:", err);
        setAssetModel([]);
        formik.setFieldValue("model", ""); // Clear model on error
      });
  };

  // Handle file selection
  const handleFiles = (files) => {
    const newImages = Array.from(files).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      New: true,
    }));
    setImages((prev) => [...prev, ...newImages]);
    formik.setFieldValue("images", [...images, ...newImages]);
    // Clear the input field value
    if (inputRef && inputRef.current) {
      inputRef.current.value = "";
    }
  };
  // Handle drag-and-drop
  const handleDrop = (event) => {
    event.preventDefault();
    handleFiles(event.dataTransfer.files);
  };

  // Remove image
  const removeImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);

    // Update Formik's value
    formik.setFieldValue("images", updatedImages);
  };

  // Open preview modal
  const openPreview = (image) => {
    setPreviewImage(image);
  };

  // Close preview modal
  const closePreview = () => {
    setPreviewImage(null);
  };

  const handleCheckUnitNumber = (values) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = `number=${values.serialNumber}&isUnitNumber=false${typeof editMachineInfo?.AssetId === "number" && editMachineInfo?.AssetId
      ? `&assetId=${editMachineInfo?.AssetId}`
      : ""
      }`;

    checkUnitNumber(payload, header, instance, accounts)
      .then((res) => {
        if (editMachineInfo?.AssetId) {
          if (values.location !== "" && values.location === values.defultLocation) {
            handleAddAsset({ ...values, LocationId: editMachineInfo.LocationId });
          } else {
            handleAddLocation(values);
          }
        } else {
          handleAddLocation(values);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(err.data.message);
        setAddMachineLoader(false);
      });
  };

  const handleAddLocation = (values) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    let payload = {
      CompanyName: "",
      Address1: values.address1,
      Address2: values.address2,
      PostalCode: values.postalCode,
      Province: "",
      Country: values.country,
      City: values.city,
      locationOptions: [],
      LocationTypesJson: "[1]",
      LocationTypes: [1],
      Latitude: values.lat,
      Longitude: values.lng,
      LocationName: values.location,
      LocationTypesCount: 1,
      Comment: "",
      center: {
        lat: formik?.values.lat,
        lng: formik?.values.lng,
      },
      check: true,
      ShowSalesTaxModal: false,
      DisplayName: formik?.values.location,
      CompanyId: azureUserInfo?.CompanyId,
    };

    if (editMachineInfo?.AssetId) {
      payload = {
        ...payload,
        LocationId: editMachineInfo.LocationId,
      };
    }

    addLocation(payload, header, instance, accounts)
      .then((res) => {
        handleAddAsset({ ...values, LocationId: res?.data?.LocationId });
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const handleAddAsset = (values, instance, accounts) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    let payload = {
      AssetStatusId: Number(values?.status),
      MakeId: Number(values?.manufacturers),
      AssetTypeId: DefaultAssetID,
      AssetDescription: values?.description,
      Year: Number(values?.year),
      Model: values?.model,
      SerialNumber: values?.serialNumber,
      Price: Number(values?.price),
      LastSMUDate: "2024-11-27T10:49:22.354Z",
      ContactId: azureUserInfo?.ContactId,
      CompanyId: azureUserInfo?.CompanyId,
      LocationId: Number(values?.LocationId),
    };

    if (editMachineInfo?.AssetId) {
      payload = {
        ...payload,
        AssetId: editMachineInfo?.AssetId,
      };
    }
    addAsset(payload, header, instance, accounts)
      .then((res) => {
        handleAddCategori(values, res.data);
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const handleAddCategori = (values, assetInfo) => {
    const selectCatagory = assetType.find((item) => Number(item.CategoryId) == Number(values?.type));
    let payload = {
      AssetId: assetInfo?.AssetId,
      AssetTypeId: DefaultAssetID,
      CategoryId: Number(values?.type),
      CategorizationBreadcrumb: `Paving Equipment // ${selectCatagory.CategoryName}`,
      CategorizationJson: `{"AssetTypeId":{"key":2,"label":"Paving Equipment"},"CategoryId":{"key":${DefaultAssetID},"label":"${selectCatagory.CategoryName}"}}`,
    };
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    addCategori(payload, header, instance, accounts)
      .then((res) => {
        uploadImg(values, assetInfo);
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data || "Error fetching companies");
      });
  };

  const uploadImg = async (values, assetInfo) => {
    try {
      const header = {
        authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
      };

      // Ensure `images` is available and not empty
      if (!images || images.length === 0) {
        toast.error("No images to upload!");
        return;
      }

      const uploadIMG = images.filter((item) => item.New);

      const uploadPromises = uploadIMG.map(async (item, index) => {
        const url = `pictureId=${assetInfo?.CompanyId}&directoryName=Dev`;
        const payload = new FormData();
        payload.append("file", item.file);

        try {
          // Upload image
          const uploadResponse = await uploadBulkImg(payload, header, url, instance, accounts);

          // Prepare payload for saving the picture
          let imgPayload = {
            Context: "Asset",
            ContextId: assetInfo?.AssetId, // Replace Asset ID
            url: uploadResponse.data.url,
            PictureUuid: uploadResponse.data.pictureUuid,
            PictureContentType: uploadResponse.data.pictureContentType,
            FileSizeInBytes: uploadResponse.data.file.Length,
            FileName: uploadResponse.data.file.FileName.substring(
              0,
              uploadResponse.data.file.FileName.lastIndexOf(".")
            ),
            FileFullName: uploadResponse.data.file.FileName,
            folderFetachParam: {
              Context: "Asset",
              ContextId: assetInfo?.AssetId, // Replace Asset ID
            },
          };

          if (index == 0) {
            imgPayload = {
              ...imgPayload,
              Main: true, // this flag working for main img set in asset for 1st img
            };
          }
          // Save the picture
          const saveResponse = await savePicture(imgPayload, header);
        } catch (uploadErr) {
          console.error("Error uploading image:", uploadErr);
          toast.error(uploadErr?.data || "Image upload failed!");
          throw uploadErr; // Propagate error for outer handling
        }
      });

      // Wait for all uploads to finish
      await Promise.all(uploadPromises);
      if (!editMachineInfo?.AssetId) {
        handleAddAdvertisements(values, assetInfo);
      } else {
        toast.success("Asset Edit Successfull");
        localStorage.removeItem("StoreMachineData");
        localStorage.removeItem("StoreMachineImg");
        setAddMachineLoader(false);
        handleResetPagination();
        handleCloseMachinePopUp();
      }
    } catch (err) {
      console.error("Error in uploadImg:", err);
      toast.error("Failed to upload images!");
      setAddMachineLoader(false);
    } finally {
    }
  };

  const handleAddAdvertisements = async (values, assetInfo) => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const url = `contactId=${azureUserInfo?.ContactId}`;

    const contactData = await getContactById(url, header, instance, accounts);
    const payload = {
      AdvertisedPrice: Number(values?.price),
      AdvertisedCurrency: values?.currency,
      AdStartDate: formatDate(new Date()),
      Description: values?.description,

      ContactName: contactData?.data?.ContactName,
      ContactEmail: contactData?.data?.Email,
      ContactPhone: contactData?.data?.Mobile,

      SortOrder: 1,
      AssetId: assetInfo?.AssetId, // Replace Asset ID
      AdvertiserId: 1,
      AdvertiserIds: [1],
    };
    addAssetAdvertisements(payload, header)
      .then((res) => {
        toast.success("List Add");
        formik.resetForm();
        localStorage.removeItem("StoreMachineData");
        localStorage.removeItem("StoreMachineImg");
        setAddMachineLoader(false);
        handleResetPagination();
        handleCloseMachinePopUp();
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const handleCloseWarning = () => {
    navigate("/");
    setOpenWarning(false);
  };

  const handleCloseWarningOnlyModel = () => {
    setOpenWarning(false);
  };

  const handleClosePendingWarning = () => {
    localStorage.removeItem("OpenWarning");
    setIsLoading(false);
    setOpenPendingWarning(false);
    navigate("/");
  };

  // Login
  const handleLogin = async () => {
    setIsLoading(true);

    setOpenWarning(false);
    try {
      const idToken = await instance.loginPopup(loginRequest);
      handleRedirectCallback(idToken.accessToken);
      localStorage.setItem("vizy-azure-token", idToken.accessToken);
    } catch (error) {
      console.error("Login error:", error);
      setIsLoading(false);
    }
  };

  const handleRedirectCallback = async (response) => {
    try {
      const decodedToken = jwtDecode(response);

      if (!decodedToken?.extension_UserStatus) {
        await handleDefaultLogin(decodedToken, response);
        return;
      }

      switch (decodedToken.extension_UserStatus) {
        case undefined:
        case "Pending":
          await handlePendingStatus();
          break;

        case "Approved":
          await handleApprovedStatus(decodedToken);
          break;

        default:
          await handleDefaultStatus();
          break;
      }
    } catch (error) {
      console.error("Error handling redirect callback:", error);
      setIsLoading(false);
    }
  };

  const handlePendingStatus = async () => {
    await instance.logoutPopup({ postLogoutRedirectUri: window.location.origin });
    handleOpenWarning();
    localStorage.removeItem("vizy-bility-token");
    localStorage.removeItem("client_info");
    setIsLoading(false);
  };

  const handleApprovedStatus = async (decodedToken) => {
    const payload = new URLSearchParams({
      grant_type: vizybilityConfig.grant_type,
      username: decodedToken.extension_GenericWebUsername,
      password: decodedToken.extension_GenericWebUserPassword,
      client_id: vizybilityConfig.STS_CLIENT_ID,
      client_secret: vizybilityConfig.STS_CLIENT_SECRET,
      scope: vizybilityConfig.STS_SCOPE,
      ApplicationId,
    });

    setIsLoading(true);
    try {
      const res = await postGetVizyBilityToken({
        url: vizybilityConfig.STS_SIGNIN_URL,
        payload,
      });

      if (res?.data?.access_token) {
        localStorage.setItem("vizy-bility-token", res.data.access_token);
        localStorage.setItem("client_info", JSON.stringify(decodedToken));

        const header = { authorization: `Bearer ${res.data.access_token}` };
        const ThirdPartyAzureToken = await getThirdPartyAzureService(header);
        const headerUser = {
          Authorization: `Bearer ${ThirdPartyAzureToken?.data?.access_token}`,
        };
        const getGenericUser = await getGenericUserKey(header);
        const applicationId = JSON.parse(getGenericUser?.data?.SettingValue)?.AzureB2CApplicationID;
        const query = `${decodedToken.sub}?$select=id,givenName,surname,identities,extension_${applicationId}_CreatedDatetime,extension_${applicationId}_UserStatus,extension_${applicationId}_ContactId,extension_${applicationId}_CompanyName,extension_${applicationId}_CompanyId,extension_${applicationId}_EmailAddresses,extension_${applicationId}_Phone,extension_${applicationId}_IsActive,extension_${applicationId}_DeactivationDatetime,extension_${applicationId}_ContactUserName`;
        const AzureUserData = await getAzureUser(query, headerUser);
        localStorage.setItem("getAzureUserData", JSON.stringify(cleanObjectKeys(AzureUserData?.data)));
        localStorage.removeItem("OpenWarning");
        setIsLoading(false);
        setOpenPendingWarning(false);
        window.location.reload();
      }
      setIsLoading(false);
    } catch (error) {
      await handlePendingStatus();
    }
  };

  const handleDefaultLogin = async (decodedToken, response) => {
    const payload = new URLSearchParams({
      grant_type: vizybilityConfig.grant_type,
      username: vizybilityConfig.GenericWebUsername,
      password: vizybilityConfig.GenericWebUserPassword,
      client_id: vizybilityConfig.STS_CLIENT_ID,
      client_secret: vizybilityConfig.STS_CLIENT_SECRET,
      scope: vizybilityConfig.STS_SCOPE,
      ApplicationId,
    });

    setIsLoading(true);
    try {
      const res = await postGetVizyBilityToken({
        url: vizybilityConfig.STS_SIGNIN_URL,
        payload,
      });

      if (res?.data?.access_token) {
        localStorage.setItem("vizy-bility-token", res.data.access_token);
        localStorage.setItem("client_info", JSON.stringify(decodedToken));
        localStorage.setItem("azuretoken", response);
        localStorage.setItem("vizy-azure-token", response);
        navigate("/admin");
      }
      setIsLoading(false);
    } catch (error) {
      await handlePendingStatus();
    }
  };

  const handleDefaultStatus = async () => {
    await handlePendingStatus();
  };

  const handleOpenWarning = () => {
    setOpenPendingWarning(true);
    localStorage.setItem("OpenWarning", true);
  };

  const handlePlaceSelect = (place, formik) => {
    const addressComponents = place?.address_components || [];

    const getComponent = (types) => {
      const component = addressComponents.find((comp) => comp.types.some((type) => types.includes(type)));

      return component ? component.long_name : "";
    };
    formik.setFieldValue(
      "location",
      `${place?.formatted_address} ${getComponent(["sublocality", "neighborhood"])} ${getComponent([
        "locality",
        "administrative_area_level_2",
      ])} ${getComponent(["administrative_area_level_1"])} ${getComponent(["country"])}` || formik.values.address1
    );

    formik.setFieldValue("address1", place?.formatted_address || formik.values.address1);
    formik.setFieldValue("address2", getComponent(["sublocality", "neighborhood"]) || "");
    formik.setFieldValue("city", getComponent(["locality", "administrative_area_level_2"]));
    formik.setFieldValue("state", getComponent(["administrative_area_level_1"]));
    formik.setFieldValue("country", getComponent(["country"]));
    formik.setFieldValue("postalCode", getComponent(["postal_code"]));
    formik.setFieldValue("lat", place?.geometry?.location?.lat());
    formik.setFieldValue("lng", place?.geometry?.location?.lng());
  };

  return (
    <>
      {addMachineLoader ? (
        <div className="absolute w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50 top-0">
          <span class="loader"></span>
        </div>
      ) : null}
      <div className="bg-white dark:bg-zinc-950 pb-[50PX]">
        <div className="custom-container">
          <div className="py-[29px]">
            <form onSubmit={formik.handleSubmit}>
              <div className="rounded-lg mb-[20px]">
                <div
                  className="bg-zinc-100 dark:bg-zinc-800 rounded-lg py-[50px] text-center cursor-pointer border border-dashed border-2"
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={handleDrop}
                  onClick={() => document.getElementById("fileInput").click()}
                >
                  <div className="flex item-center justify-center mb-[20px]">
                    <img src={Upload} alt="Upload" />
                  </div>
                  <div className="block text-[Roboto] text-[16px] font-normal text-[#A9A9A9]">
                    {registeringForm.DRAG_AND_DROP}
                  </div>
                  <input
                    type="file"
                    id="fileInput"
                    className="hidden"
                    multiple
                    accept="image/*"
                    ref={inputRef}
                    onChange={(e) => handleFiles(e.target.files)}
                  />
                </div>
                {formik.touched.images && formik.errors.images ? (
                  <p className="text-red-400 mt-1 text-[14px]">{formik.errors.images}</p>
                ) : null}

                <div className="mt-[20px] grid 2xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-[20px]">
                  {images.map((image, index) => (
                    <div key={index} className="relative group border rounded-lg overflow-hidden">
                      {/* Image */}
                      <img src={image.preview} alt={`Preview ${index}`} className="w-full h-[170px] object-cover" />

                      {/* Hover Preview */}
                      <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <button
                          className="text-white text-sm bg-gray-700 py-1 px-3 rounded hover:bg-gray-800"
                          onClick={() => openPreview(image.preview)}
                        >
                          Preview
                        </button>
                      </div>

                      {/* Remove Button */}
                      <button
                        className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-1 text-xs hover:bg-red-700 w-[20px] h-[20px]"
                        onClick={() => removeImage(index)}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="grid l md:grid-cols-2 grid-cols-1 gap-4">
                <div>
                  <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">Year</label>
                  <input
                    type="number"
                    name="year"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.year}
                    placeholder="Enter here"
                    className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.year && formik.errors.year ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.year}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">
                    Manufacturer
                  </label>
                  <select
                    name="manufacturers"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.manufacturers}
                    className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  >
                    <option value="" className="text-[16px] font-[Roboto]" disabled>
                      <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Manufacturers</div>
                    </option>
                    {assetMake.map((item) => {
                      return (
                        <option value={item.MakeId} className="text-[16px]  font-[Roboto]">
                          <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.MakeName}</div>
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.manufacturers && formik.errors.manufacturers ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.manufacturers}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">
                    Model
                  </label>
                  <select
                    name="model"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.model}
                    disabled={!formik.values.manufacturers || assetModel.length === 0}
                    className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <option value="" className="text-[16px] font-[Roboto]" disabled>
                      <div className="!my-[10px] !mx-[30px] leading-[200px]">
                        {!formik.values.manufacturers ? "Please select a manufacturer first" : assetModel.length === 0 ? "Loading models..." : "Select Model"}
                      </div>
                    </option>
                    {assetModel.map((item) => {
                      return (
                        <option value={item.Model} className="text-[16px]  font-[Roboto]">
                          <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.Model}</div>
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.model && formik.errors.model ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.model}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">
                    Serial Number
                  </label>
                  <input
                    type="text"
                    name="serialNumber"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.serialNumber}
                    placeholder="Enter here"
                    className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.serialNumber && formik.errors.serialNumber ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.serialNumber}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">
                    Category
                  </label>
                  <select
                    name="type"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.type}
                    className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  >
                    <option value="" className="text-[16px] font-[Roboto]" disabled>
                      <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Category</div>
                    </option>
                    {assetType.map((item) => {
                      return (
                        <option value={item.CategoryId} className="text-[16px] font-[Roboto]">
                          <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.CategoryName}</div>
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.type && formik.errors.type ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.type}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">
                    Machine Hours As of
                  </label>
                  <input
                    type="text"
                    name="machineHours"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.machineHours}
                    placeholder="Enter here"
                    className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.machineHours && formik.errors.machineHours ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.machineHours}</p>
                  ) : null}
                </div>

                {/* <div>
                  <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">
                    Sort Order
                  </label>
                  <input
                    type="number"
                    name="sortOrder"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.sortOrder}
                    placeholder="Enter here"
                    className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.sortOrder && formik.errors.sortOrder ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.sortOrder}</p>
                  ) : null}
                </div> */}

                {/* <div>
                  <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">Status</label>
                  <select
                    name="status"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.status}
                    className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  >
                    <option value="" className="text-[16px] text-[#161616] font-[Roboto]" disabled>
                      <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Status</div>
                    </option>
                    {assetStatus.map((item) => {
                      return (
                        <option value={item.AssetStatusId} className="text-[16px] text-[#161616] font-[Roboto]">
                          <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.AssetStatusName}</div>
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.status && formik.errors.status ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.status}</p>
                  ) : null}
                </div> */}

                <div>
                  <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">
                    Price
                  </label>
                  <input
                    type="number"
                    name="price"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.price}
                    placeholder="Enter here"
                    className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.price && formik.errors.price ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.price}</p>
                  ) : null}
                </div>
              </div>

              <div className="mt-[15px]">
                <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">
                  Location
                </label>
                <GooglePlacesAutocomplete
                  apiKey={Google_map_Key}
                  onPlaceSelected={(place) => handlePlaceSelect(place, formik)}
                  onChange={(e) => {
                    formik.setValues({
                      ...formik.values,
                      location: e.target.value,
                    });
                  }}
                  options={{
                    types: ["address"],
                  }}
                  value={formik.values.location}
                  className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                />
                {formik.touched.location && formik.errors.location ? (
                  <p className="text-red-400 mt-1 text-[14px]">{formik.errors.location}</p>
                ) : null}
              </div>

              <div className="mt-[20px]">
                <label className="block text-[Roboto] text-black dark:text-white text-[16px] font-normal">
                  Description
                </label>
                <textarea
                  type="text"
                  name="description"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.description}
                  placeholder="Enter here"
                  className="input bg-zinc-100 dark:bg-zinc-800 border border-[#F2F2F2] text-black dark:text-white w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                />
                {formik.touched.description && formik.errors.description ? (
                  <p className="text-red-400 mt-1 text-[14px]">{formik.errors.description}</p>
                ) : null}
              </div>

              <div className="text-center absolute bottom-0 bg-zinc-100 dark:bg-zinc-950 w-full right-0 py-[20px]">
                {/* <button
                  disabled={addMachineLoader}
                  type="submit"
                  className="border border-[#FEBA06] bg-[#FEBA06] px-[90px] py-[15px] font-bold text-[16px] font-bold font-[Roboto] rounded-lg text-[#161412]"
                >
                  {addMachineLoader ? <span class="btn-loader"></span> : registeringForm.LIST_MY_MACHINE}
                </button> */}

                <Button
                  variant="outline"
                  color="zinc"
                  icon="HeroXCircle"
                  type="button"
                  className="mr-[15px]"
                  onClick={() => handleCloseMachinePopUp()}
                >
                  Cancel
                </Button>
                <Button variant="solid" icon="HeroPencil" type="submit" className="ml-[15px]">
                  Save
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Modal for Preview */}
      {previewImage && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="relative bg-zinc-100 dark:bg-zinc-800 p-4 rounded-lg max-w-[90%] max-h-[90%]">
            <button
              className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 hover:bg-red-700  w-[30px] h-[30px] cursor-pointer flex items-center justify-center"
              onClick={closePreview}
            >
              ✕
            </button>
            <img src={previewImage} alt="Preview" className="max-w-full max-h-[80vh] object-contain" />
          </div>
        </div>
      )}

      <SignUpWarningModel
        open={openWarning}
        setOpen={setOpenWarning}
        handleClose={handleCloseWarning}
        handleCloseWarningOnlyModel={handleCloseWarningOnlyModel}
        handleLogin={() => openModal("login")}
      />

      <WarningModal open={openPendingWarning} handleClose={handleClosePendingWarning} />
    </>
  );
};
export default AddAdminMachineForm;
